import MeetingsAPI from 'dashboard/api/meetings';
import UserAgendaAPI from 'dashboard/api/userAgenda';
import { mutationTypes } from './mutations';

// navegar rápido entre semanas ou digitar na busca dispara vários fetches;
// só a resposta do último pode gravar, senão uma lenta sobrescreve a atual
let latestFetchId = 0;

export default {
  async fetchMeetings({ commit }, params = {}) {
    latestFetchId += 1;
    const fetchId = latestFetchId;
    commit(mutationTypes.SET_UI_FLAG, { isLoading: true });
    try {
      const { data } = await MeetingsAPI.list(params);
      if (fetchId === latestFetchId) commit(mutationTypes.SET_MEETINGS, data);
    } catch (error) {
      // silently handle
    } finally {
      if (fetchId === latestFetchId) {
        commit(mutationTypes.SET_UI_FLAG, { isLoading: false });
      }
    }
  },

  async fetchMeetingsRaw(_, params = {}) {
    return MeetingsAPI.list(params);
  },

  async fetchMeeting({ commit }, meetingId) {
    try {
      const { data } = await MeetingsAPI.show(meetingId);
      commit(mutationTypes.SET_MEETING, data);
    } catch (error) {
      // silently handle
    }
  },

  async createMeeting({ commit }, meetingData) {
    commit(mutationTypes.SET_UI_FLAG, { isSaving: true });
    try {
      const { data } = await MeetingsAPI.create(meetingData);
      commit(mutationTypes.ADD_MEETING, data);
      return data;
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { isSaving: false });
    }
  },

  async updateMeeting({ commit }, { id, ...meetingData }) {
    commit(mutationTypes.SET_UI_FLAG, { isSaving: true });
    try {
      const { data } = await MeetingsAPI.update(id, meetingData);
      commit(mutationTypes.UPDATE_MEETING, data);
      return data;
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { isSaving: false });
    }
  },

  async deleteMeeting({ commit }, meetingId) {
    await MeetingsAPI.destroy(meetingId);
    commit(mutationTypes.REMOVE_MEETING, meetingId);
  },

  async bulkUpdateMeetings({ commit }, { ids, ...data }) {
    commit(mutationTypes.SET_UI_FLAG, { isSaving: true });
    try {
      const { data: meetings } = await MeetingsAPI.bulkUpdate(ids, data);
      meetings.forEach(m => commit(mutationTypes.UPDATE_MEETING, m));
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { isSaving: false });
    }
  },

  async fetchAgenda({ commit }) {
    try {
      const { data } = await UserAgendaAPI.get();
      commit(mutationTypes.SET_AGENDA, data);
    } catch (error) {
      // silently handle
    }
  },

  async updateAgenda({ commit }, agendaData) {
    const { data } = await UserAgendaAPI.update(agendaData);
    commit(mutationTypes.SET_AGENDA, data);
    return data;
  },

  async updateMeetingField({ commit }, { id, ...fields }) {
    try {
      const { data } = await MeetingsAPI.update(id, fields);
      commit(mutationTypes.UPDATE_MEETING, data);
      commit(mutationTypes.SET_MEETING, data);
      return data;
    } catch (error) {
      // silently handle
      return undefined;
    }
  },
};
